import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Link } from 'react-router-dom';
import api from '@/services/api';

interface SeasonalAlert {
  id: string;
  title: string;
  message: string;
  emoji: string;
  linkUrl?: string;
}

export const SeasonalAlertBanner = () => {
  const [alerts, setAlerts] = useState<SeasonalAlert[]>([]);
  const [dismissed, setDismissed] = useState<string[]>(() => {
    try { return JSON.parse(localStorage.getItem('dismissed_alerts') || '[]'); } catch { return []; }
  });

  useEffect(() => {
    const cached = sessionStorage.getItem('seasonal_alerts');
    if (cached) { try { setAlerts(JSON.parse(cached)); return; } catch { /* refetch */ } }
    api.get('/seasonal-alerts').then(r => {
      const data = r.data.data || [];
      setAlerts(data);
      sessionStorage.setItem('seasonal_alerts', JSON.stringify(data));
    }).catch(() => {});
  }, []);

  const dismiss = (id: string) => {
    const next = [...dismissed, id];
    setDismissed(next);
    localStorage.setItem('dismissed_alerts', JSON.stringify(next));
  };

  const visible = alerts.filter(a => !dismissed.includes(a.id));
  if (visible.length === 0) return null;

  const alert = visible[0];

  return (
    <div className="bg-gradient-to-r from-primary-600 to-primary-700 text-white px-4 py-2.5">
      <div className="max-w-7xl mx-auto flex items-center gap-3">
        <span className="text-xl shrink-0">{alert.emoji}</span>
        <div className="flex-1 min-w-0">
          <span className="font-semibold text-sm">{alert.title}: </span>
          <span className="text-sm text-primary-100">{alert.message}</span>
        </div>
        {alert.linkUrl && (
          <Link to={alert.linkUrl} className="shrink-0 text-xs bg-white/20 hover:bg-white/30 px-3 py-1 rounded-full transition-all">
            Shop Now
          </Link>
        )}
        <button onClick={() => dismiss(alert.id)} className="shrink-0 text-primary-200 hover:text-white">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};
